module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c4ceba83cf15016aa9c2cf6c3b9c764b.jpg";